module.exports = __webpack_public_path__ + "static/media/Vectorup.f9d500e8.svg";